var $ = require('jquery');
var _ = require('lodash');
var breakpoint = require('common/breakpoint');
require('common/facebook');
require('common/ruutuembed');
require('./news');
require('./newsitemhit');

var resize = function () {
    var iframe = $('iframe.dreambroker'),
        ratio = 854 / 480;
    iframe.css('height', iframe.width() / ratio);
};

$(function() {
    $(window).on('resize orientationchange', _.throttle(resize, 500));
    resize();
});



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/site/js/video.js
// module id = 14
// module chunks = 0